import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  ssccContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "8px",
    border: "1px solid #E4E7EC",
    borderRadius: "8px",
    padding: "4px 12px",
    font: "normal 600 18px/24px Manrope",
    color: "#465869",
  },
  ssccQuantity: {
    font: "normal 700 18px Manrope",
  },
  leftMargin: {
    marginLeft: "8px",
  },
  rowCenter: {
    width: "max-content",
    display: "flex",
    alignItems: "center",
    gap: "16px",
  },
}));

export default styles;
